export default __webpack_public_path__ + "static/media/Astronaut-one.8db43b9b.svg";